import constants from '../constants';

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
);

export function getRoleName(id) {
  const role = Object.values(constants.roles).find(item => item.id === id);
  if (!role) return '-';
  return role.name;
}

export function getNewDate() {
  return new Date();
}

export function getOnlyDate(date) {
  return new Date(date.toISOString().split('T')[0]);
}